import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useCallback, useEffect, useState } from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { useIsFocused } from "@react-navigation/native";
import ScreenLoader from "../ScreenLoader";
import api from "../../services/api";
import styles from "./styles";
import { FormattedMessage } from "react-intl";
import { decode } from "html-entities";

const CardsActives = ({ selectedCategoryAction }) => {
  const [categories, setCategories] = useState([]);
  const isFocused = useIsFocused();
  const [loading1, setLoading1] = useState(false);
  const [lang, setLang] = useState("");

  const decodeHtml = (html) => {
    return decode(html);
  };

  const getLang = async () => {
    const langFromStorage = await AsyncStorage.getItem("lang");
    setLang(langFromStorage);
  };

  const translate = async (text, country, lang) => {
    if (country === "brasil" && lang === "pt-BR") {
      return text;
    } else if (country === "italia" || lang === "it") {
      try {
        const token = await AsyncStorage.getItem("JWT_TOKEN");
        const response = await api.post(
          `/language-translation`,
          { text: text, target_language: "it" },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        return response?.data?.translation || text;
      } catch (error) {
        return text;
      }
    } else if (lang === "en") {
      try {
        const token = await AsyncStorage.getItem("JWT_TOKEN");
        const response = await api.post(
          `/language-translation`,
          { text, target_language: "en" },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        return response?.data?.translation || text;
      } catch (error) {
        return text;
      }
    }
    return text;
  };

  useEffect(() => {
    const loadLangAndCategories = async () => {
      await getLang();
      await getCategories();
    };

    loadLangAndCategories();
  }, [isFocused]);

  async function getCategories() {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    const clientCountry = await AsyncStorage.getItem("client_country");
    const lang = await AsyncStorage.getItem("lang");

    setLoading1(true);
    try {
      const {
        data: [items],
      } = await api.get("/categories", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const filteredCategories = items.filter((item) => {
        const isIRec = clientCountry === "italia" && item.name === "I-REC";
        const isSustentavel =
          clientCountry !== "brasil" && item.name.includes("Sustentável");
        const isPromocional = item.name.toLowerCase().includes("promocional");

        return !isIRec && !isSustentavel && !isPromocional;
      });

      const translatedCategories = await Promise.all(
        filteredCategories.map(async (item) => ({
          ...item,
          name: await translate(item.name, clientCountry, lang),
          description: await translate(item.description, clientCountry, lang),
        }))
      );

      setCategories(translatedCategories);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading1(false);
    }
  }

  function selectedCategory(id, name) {
    selectedCategoryAction(id, name);
  }

  async function handlePress(item) {
    if (item.adoption) {
      try {
        const token = await AsyncStorage.getItem("JWT_TOKEN");
        const langFromStorage = await AsyncStorage.getItem("lang");
        let baseUrl;

        const url = window.location.href;
        if (url.includes("localhost")) {
          baseUrl = "http://localhost";
        } else if (url.includes("homol.gpxecofi.com.br")) {
          baseUrl = "https://api.homol.gpxecofi.com.br";
        } else {
          baseUrl = "http://api.gpxecofi.com.br";
        }

        const fullUrl = `${baseUrl}/${langFromStorage}/trees?token=${token}`;

        if (token) {
          window.open(fullUrl, "_blank");
        } else {
          console.error("Token não encontrado.");
        }
      } catch (error) {
        console.error("Erro ao buscar o token:", error);
      }
    } else {
      selectedCategory(item.id, item.name);
    }
  }

  //*CARD PRODUTOS

  const renderItem = useCallback((item) => {
    return (
      <View style={styles.card} key={item.id}>
        <View>
          <Image
            style={styles.frontCover}
            source={{
              uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${item.path}`,
            }}
          />
        </View>
        <View style={styles.contentDescription}>
          <Text style={styles.nameCategoryOnDescription}>
            {decodeHtml(item.name)}
          </Text>
          <Text style={styles.textDescription}>
            {decodeHtml(item.description)}
          </Text>
          <View style={styles.contentBtn}>
            <TouchableOpacity
              style={styles.button}
              onPress={() => handlePress(item)}
            >
              <Text style={styles.textBtn}>
                <FormattedMessage id="marketplacecategories.queroInvestir" />
              </Text>
            </TouchableOpacity>
            {/* Novo botão condicional */}
            {/*   {item.name.includes("USE") &&
              (window.location.href.includes("localhost") ||
                window.location.href.includes("homol.gpxecofi.com.br")) && (
                <TouchableOpacity
                  style={styles.button}
                  onPress={() => {
                    window.open(
                      "https://api.homol.gpxecofi.com.br/gpx-agro-carbon",
                      "_blank"
                    );
                  }}
                >
                  <Text style={styles.textBtn}>Agro Carbon</Text>
                </TouchableOpacity>
              )} */}
          </View>
        </View>
      </View>
    );
  }, []);

  return (
    <>
      <ScreenLoader loading={loading1} />
      <View style={styles.container}>
        {categories.map((item) => renderItem(item))}
      </View>
    </>
  );
};

export default CardsActives;
